import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import DownloadSharpIcon from "@mui/icons-material/DownloadSharp";

import { useQnaDetail } from "../../api/qnaApi";
import { translator } from "../../utils/translator";
import { type Role } from "../../types/user";

const QnaDetail = ({ role }: { role: Role }) => {
  const { id } = useParams() as { id: string };
  const { data, isLoading } = useQnaDetail({ id });
  const question = useMemo(() => data?.question, [data]);

  if (isLoading || !data) return <p>로딩 중</p>;

  return (
    <div className="narrowContent">
      <Link to={`..${window.location.search}`} className="moveButton">
        목록으로
      </Link>
      <h3 style={{ backgroundColor: "var(--primary-200)" }}>게시글</h3>
      <p>
        <b>제목:</b> {question.title}
      </p>
      <p>
        <b>의견 구분:</b> {translator[question.type]}
      </p>
      <p>
        <b>처리 상태:</b> {translator[question.status]}
      </p>
      <p>
        <b>작성자:</b> {question.user_name}
      </p>
      {role === "staff" && (
        <>
          <p>
            <b>전화번호:</b> {question.phone}
          </p>
          <p>
            <b>이메일:</b> {question.email}
          </p>
          <p>
            <b>학생코드:</b> {question.user_code}
          </p>
        </>
      )}
      <p>
        <b>작성일시:</b> {moment(question.created_at).format("YYYY-MM-DD LT")}
      </p>
      <hr />
      <p>
        <b>내용</b>
      </p>
      <div style={{ whiteSpace: "pre-line" }}>{question.content}</div>
      <hr />
      <div>
        <p>
          <b>첨부파일</b>
        </p>
        {question.signed_urls?.length
          ? question.signed_urls.map(
              ({ filename, url }: { filename: string; url: string }) => (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-button"
                >
                  <DownloadSharpIcon /> {filename}
                </a>
              )
            )
          : "없음"}
      </div>
      <h3 style={{ backgroundColor: "var(--primary-200)" }}>답변</h3>
      {question.status === "answered" ? (
        <>
          <p>
            <b>답변일시:</b>{" "}
            {moment(question.answer.created_at).format("YYYY-MM-DD LT")}
          </p>
          <div style={{ whiteSpace: "pre-line" }}>
            {question.answer.content}
          </div>
        </>
      ) : (
        <p>답변이 등록되지 않았습니다.</p>
      )}
    </div>
  );
};

export default QnaDetail;
